<template>
  <div class="c-lang-switcher">
    <a :href="url" @click.prevent="switchLang" class="c-lang-switcher__btn">
      <span>{{ newLang.toUpperCase() }}</span>
    </a>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

const { mapState, mapMutations } = createNamespacedHelpers("app")

export default {
  name: "LangSwitcher",
  computed: {
    ...mapState(["lang"]),
    newLang() {
      return this.lang === "fr" ? "en" : "fr"
    },
    url() {
      const protocol = window.location.protocol
      const hostname =
        this.lang === "en"
          ? process.env.VUE_APP_DOMAIN_FR
          : process.env.VUE_APP_DOMAIN_EN
      return `${protocol}//${hostname}${this.$route.fullPath}`
    }
  },
  methods: {
    ...mapMutations(["setLang"]),
    switchLang() {
      // local dev
      //if (
      //  window.location.hostname !== process.env.VUE_APP_DOMAIN_FR &&
      //  window.location.hostname !== process.env.VUE_APP_DOMAIN_EN
      //) {
      this.setLang(this.newLang)
      //return
      //}
      //
      //window.location.assign(this.url)
    }
  }
}
</script>

<style scoped></style>
